import { Injectable } from "@angular/core";
import { environment as env } from "../../../environments/environment";
import { StorageRef } from "../storage/storage.service";

@Injectable()
export class FlagsRef {
    constructor(private storage: StorageRef) {
        this.storage.set("featureFlags", env.flags);
        this.storage.set("featureFlagsSet", true);
    }

    public isOn(flag: string) {
        const flags = this.storage.get("featureFlags");
        if (!!flags) {
            return flags[flag];
        } else {
            return false;
        }
    }

    public isOff(flag: string) {
        return !this.isOn(flag);
    }
}
